/* ==========================================
   CART.JS — FINAL FIXED VERSION (Ride Theme)
   ========================================== */

function debounce(func, wait) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

/* ===============================
   Cart Remove Button
   =============================== */
if (!customElements.get('cart-remove-button')) {
  class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        updateCartQty(this.dataset.index, 0);
      });
    }
  }
  customElements.define('cart-remove-button', CartRemoveButton);
}

/* ===============================
   Quantity Input ( + / - )
   =============================== */
// تم إلغاء quantity-input نهائياً واستبداله بـ gh-qty

/* ===============================
   Update Cart Quantity
   =============================== */
function updateCartQty(line, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: Number(line),
      quantity: Number(qty),
      sections: ['cart-drawer'],
      sections_url: window.location.pathname,
    })
  })
    .then(res => res.json())
    .then(data => {

      /* ============ تحديث محتوى الدراور ============ */
      if (data.sections?.['cart-drawer']) {
        const parser = new DOMParser();
        const newHTML = parser
          .parseFromString(data.sections['cart-drawer'], 'text/html')
          .querySelector('#CartDrawer');

        const drawer = document.getElementById('CartDrawer');
        if (drawer && newHTML) {
          drawer.innerHTML = newHTML.innerHTML;
        }
      }

      /* ======================================================
     تحديث المظهر العام عند تحديث السلة الخارجية
====================================================== */



      /* ============ إعادة تشغيل عناصر + / - / حذف ============ */
      reBindCartElements();

      /* ============ فتح السلة بعد التعديل ============ */
      if (window.openCartDrawer) window.openCartDrawer();
    })
    .catch(console.error);
}

/* ===============================
   Rebind After DOM Update
   =============================== */
function reBindCartElements() {
  document
    .querySelectorAll('gh-qty')
    .forEach(el => new GHQCore(el));

  document
    .querySelectorAll('gh-remove-button')
    .forEach(el => new GHXRemove(el));
}
/* ============================================
   🛑 تعطيل سكربت Shopify المسبب للطلب المكرر
============================================ */
if (window.updateCartQty) {
  window.updateCartQty = function () {
  };
}

/* لبعض الثيمات — حماية إضافية */
if (window.Shopify && window.Shopify.updateCartQty) {
  window.Shopify.updateCartQty = function () {
    console.warn("Shopify default updateCartQty blocked.");
  };
}